import createIcon from '../../createIcon';

/**
 * @component @name FolderDelete
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjIgOFYxOEMyMiAxOS4xIDIxLjEgMjAgMjAgMjBINEMyLjkgMjAgMiAxOS4xIDIgMThMMi4wMSA2QzIuMDEgNC45IDIuOSA0IDQgNEgxMEwxMiA2SDIwQzIxLjEgNiAyMiA2LjkgMjIgOFpNMTYuNSAxMFY5SDE0LjVWMTBIMTJWMTEuNUgxM1YxNS41QzEzIDE2LjMzIDEzLjY3IDE3IDE0LjUgMTdIMTYuNUMxNy4zMyAxNyAxOCAxNi4zMyAxOCAxNS41VjExLjVIMTlWMTBIMTYuNVpNMTYuNSAxNS41SDE0LjVWMTEuNUgxNi41VjE1LjVaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const FolderDelete = createIcon('FolderDelete', [
  [
    'path',
    {
      d: 'M22 8V18C22 19.1 21.1 20 20 20H4C2.9 20 2 19.1 2 18L2.01 6C2.01 4.9 2.9 4 4 4H10L12 6H20C21.1 6 22 6.9 22 8ZM16.5 10V9H14.5V10H12V11.5H13V15.5C13 16.33 13.67 17 14.5 17H16.5C17.33 17 18 16.33 18 15.5V11.5H19V10H16.5ZM16.5 15.5H14.5V11.5H16.5V15.5Z',
      key: '10y2or',
    },
  ],
]);

export default FolderDelete;
